package com.macrofocus.eflux.components

import com.macrofocus.common.selection.MutableSelection
import com.macrofocus.common.selection.MutableSingleSelection
import com.macrofocus.eflux.DataLoader
import com.macrofocus.eflux.network.coordinate.Coordinate
import com.macrofocus.eflux.ui.PaletteType
import com.macrofocus.eflux.ui.data.CoordinateButton
import com.macrofocus.eflux.ui.data.risk.*
import i18next.useTranslation
import mui.material.Stack
import mui.material.StackDirection
import mui.material.Typography
import mui.material.TypographyAlign
import mui.material.styles.Theme
import mui.material.styles.TypographyVariant
import mui.material.styles.useTheme
import mui.system.Box
import mui.system.responsive
import mui.system.sx
import react.FC
import react.PropsWithChildren
import react.ReactNode
import web.cssom.*

external interface CoordinateInfoProps : PropsWithChildren {
    var probing: MutableSingleSelection<Coordinate>
    var selection: MutableSelection<Coordinate>
    var dataLoader: DataLoader
    var coordinate: Coordinate?
}

val CoordinateInfo = FC<CoordinateInfoProps> { props ->
    val theme = useTheme<Theme>()
    val paletteType = if (theme.asDynamic().palette.mode == "dark") PaletteType.dark else PaletteType.light
    val (t, _) = useTranslation()

    val coordinate = props.coordinate

    Stack {
        sx {
            minHeight = 200.px
        }

        direction = responsive(StackDirection.column)

//        val longitude = coordinate.physicalGeometry?.x
//        val latitude = coordinate.physicalGeometry?.y

//        Typography {
//            align = TypographyAlign.center
//            variant = TypographyVariant.subtitle2
//            +"$latitude, $longitude"
//        }
        Box {
            sx {
                display = Display.flex
                justifyContent = JustifyContent.center // centers horizontally
                // alignItems = "center" // use if you also want vertical centering
                width = "1.0".unsafeCast<Width>() // takes full width of parent
                maxWidth = 280.px
                overflowY = Overflow.clip
            }
            CoordinateButton {
                this.dataLoader = props.dataLoader
                this.primary = null
                this.probing = props.probing
                this.selection = props.selection
                this.coordinate = coordinate
                this.filled = true
            }
        }

//        Stack {
//            direction = responsive(StackDirection.row)
//            asDynamic().justifyContent = JustifyContent.center
//
//            if (coordinate?.risk_list != null) {
//                coordinate.risk_list.split(",").forEach {
//                    RiskTypeChip {
//                        this.riskType = it
//                    }
//                }
//            } else {
//                RiskTypeChip {
//                    this.riskType = "no risk"
//                }
//            }
//        }

        var lightning_hit = 0
        var lightning_activity = 0
        var lightning_expected = 0
        var flooding = 0
        var mudslide = 0
        var wind_gusts = 0
        var temperature = 0

        coordinate?.risk_map?.let {
            if (it and LightningHitBit != 0) lightning_hit++
            if (it and LightningActivityBit != 0) lightning_activity++
            if (it and LightningExpectedBit != 0) lightning_expected++
            if (it and FloodingBit != 0) flooding++
            if (it and MudslideBit != 0) mudslide++
            if (it and WindGustsBit != 0) wind_gusts++
            if (it and TemperatureBit != 0) temperature++
        }

        mui.material.Box {
            sx {
                display = Display.flex
                flexWrap = FlexWrap.nowrap
                gap = 10.px
                marginTop = 16.px
                justifyContent = JustifyContent.center
                marginBottom = 16.px
            }

            TemperatureBadge {
                if (temperature > 0) {
                    badgeContent = ReactNode(temperature.toString())
//                    disabled = riskFilter and TemperatureBit == 0
                } else {
                    disabled = true
                }
            }

            WindGustsBadge {
                if (wind_gusts > 0) {
                    badgeContent = ReactNode(wind_gusts.toString())
//                    disabled = riskFilter and WindGustsBit == 0
                } else {
                    disabled = true
                }
            }

            MudslideBadge {
                if (mudslide > 0) {
                    badgeContent = ReactNode(mudslide.toString())
//                    disabled = riskFilter and MudslideBit == 0
                } else {
                    disabled = true
                }
            }

            FloodingBadge {
                if (flooding > 0) {
                    badgeContent = ReactNode(flooding.toString())
//                    disabled = riskFilter and FloodingBit == 0
                } else {
                    disabled = true
                }
            }

            LightningHitBadge {
                if (lightning_hit > 0) {
                    badgeContent = ReactNode(lightning_hit.toString())
//                    disabled = riskFilter and LightningHitBit == 0
                } else {
                    disabled = true
                }
            }

            LightningExpectedBadge {
                if (lightning_expected > 0) {
                    badgeContent = ReactNode(lightning_expected.toString())
//                    disabled = riskFilter and LightningExpectedBit == 0
                } else {
                    disabled = true
                }
            }

            LightningActivityBadge {
                if (lightning_activity > 0) {
                    badgeContent = ReactNode(lightning_activity.toString())
//                    disabled = riskFilter and LightningActivityBit == 0
                } else {
                    disabled = true
                }
            }
        }

        if(coordinate?.t_70m != null) {
            WeatherPanel {
                this.temperature = "${coordinate.t_70m}°C"
                this.wind = "${coordinate.wind_speed_70m} km/h"
                this.gust = "${coordinate.wind_gusts_70m_1h} km/h"
                this.precipitation = "${coordinate.precip_5min} mm"
                this.lightning = "?"
            }
//            Thermometer {
//                min = -50.0
//                max = 50.0
//                minThreshold = -25.0
//                maxThreshold = 35.0
//                value = coordinate.t_70m
//                width = 100 / 4
//                height = 360 / 4
//            }
        }

        if (coordinate?.risk_list != null) {
            Typography {
                align = TypographyAlign.center
                variant = TypographyVariant.subtitle2
                +"${
                    coordinate.description
                        ?.replace("[\"\"],", "")
                        ?.replace("[\"\"]", "")
                        ?.replace("[", "")
                        ?.replace("]", "")
                        ?.replace("\".", ". ")
                        ?.replace("\"", "")
                }"
            }
        }
    }
}
